import http from "../api";
import fileHttp from "../api/fileApi";

export const getAllChargersData = async (data) => {
  const { page, limit, filters } = data;
  let url = `/charger-data/get-all-charger-data?page=${page}&limit=${limit}`;
  if (filters && Object.keys(filters).length > 0) {
    Object.keys(filters).forEach((fl) => {
      url = url + `${filters[fl] ? `&filters[${fl}]=${filters[fl]}` : ""}`;
    });
  }
  return await http.get(url);
};

export const addChargerData = async (data) => {
  return await http.post("/charger-data/add-charger-data", data);
};

export const exportChargerData = async () => {
  return await http.get("/charger-data/export-charger-data");
};

export const getChargerDataUpdatedTime = async () => {
  return await http.get("/charger-data/get-charger-data-time");
};

export const uploadChargersDataFile = async (data) => {
  return await fileHttp.post("/charger-data/upload-file", data);
};
